import React, { useState, useRef } from "react";
import {
  Box,
  Popper,
  Paper,
  MenuItem,
  MenuList, // ✅ ADD THIS
  ClickAwayListener,
  IconButton,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  defaultCountries,
  FlagImage,
  parseCountry,
} from "react-international-phone";

const MuiFlagSelect = ({ onSelect, selectedIso2 }) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleSelect = (country) => {
    onSelect?.(country);
    setOpen(false);
  };

  return (
    <Box>
      {/* Trigger */}
      <IconButton ref={anchorRef} onClick={() => setOpen((prev) => !prev)} size="small">
        <FlagImage iso2={selectedIso2.iso2} style={{ width: 18 }} />
        <ExpandMoreIcon fontSize="small" />
      </IconButton>

      {/* Dropdown */}
      <Popper open={open} anchorEl={anchorRef.current} placement="bottom-start">
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <Paper sx={{ maxHeight: 300, overflowY: "auto" }}>
            
            {/* ✅ Wrap MenuItem inside MenuList */}
            <MenuList>
              {defaultCountries.map((code) => {
                const country = parseCountry(code);

                return (
                  <MenuItem
                    key={country.iso2}
                    onClick={() => handleSelect(country)}
                  >
                    <Box 
                    display="flex" d
                    sx={{alignItems: 'center'}}
                    gap={1}>
                      <FlagImage iso2={country.iso2} style={{ width: 20 }} />
                      <Typography variant="body2">
                        {country.name} (+{country.dialCode})
                      </Typography>
                    </Box>
                  </MenuItem>
                );
              })}
            </MenuList>

          </Paper>
        </ClickAwayListener>
      </Popper>
    </Box>
  );
};

export default MuiFlagSelect;